document.addEventListener('DOMContentLoaded', function () {
  var banners = document.querySelectorAll('.subscription-banner');
  if (!banners.length) return;

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.8 }
  );

  banners.forEach(function (banner) {
    observer.observe(banner);
  });
});
